import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Element } from '../../../../../../../common/html/element'
import { SelectCustom } from '../../../../../../../common/selectCustom'
import { getHighlightScore, selectTypePeriod } from '../../../../../store/slice'
import { selectListFilterTimeHistoricalChange } from '../../../../store/slice'
import { getHistoricalChangeThunk } from '../../../../store/thunk'
import { formatListFilterTime, parseValueToParams } from '../helper'
import s from './index.module.scss'

const FilterTime = ({ filterTime, onFilterTimeChange }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const timeFrequency = useSelector(selectTypePeriod)
  const listFilterTime = useSelector(selectListFilterTimeHistoricalChange)
  const { riskScore } = useSelector(getHighlightScore())
  const isDisabled = riskScore === null || riskScore === undefined
  const options = formatListFilterTime(
    listFilterTime,
    timeFrequency,
    isDisabled,
  )

  // Use props instead of local state
  const { from, to } = filterTime

  // Reset from/to khi timeFrequency hoặc options thay đổi
  useEffect(() => {
    if (options.length > 0) {
      const newFrom = options[options.length - 1] // nhỏ nhất
      const newTo = options[0] // lớn nhất
      onFilterTimeChange({
        from: newFrom,
        to: newTo,
        timeFrequency,
      })
      const fromParams = parseValueToParams(newFrom, timeFrequency)
      const toParams = parseValueToParams(newTo, timeFrequency)
      dispatch(
        getHistoricalChangeThunk({
          OrganizationId: params.organizationId,
          TimeFrequency: timeFrequency,
          FromYear: fromParams.Year || '',
          FromQuater: fromParams.Quarter || '',
          FromMonth: fromParams.Month || '',
          ToYear: toParams.Year || '',
          ToQuater: toParams.Quarter || '',
          ToMonth: toParams.Month || '',
        }),
      )
    }
  }, [timeFrequency, JSON.stringify(options)])

  // Handler for select change
  const handleChooseFrom = (item) => {
    const fromIndex = options.findIndex((opt) => opt.value === item.value)
    const toIndex = to ? options.findIndex((opt) => opt.value === to.value) : -1
    let newFrom = item
    let newTo = to
    // Nếu chọn from mới hơn to (fromIndex < toIndex) thì cập nhật to = from
    if (to && fromIndex < toIndex) {
      newTo = item
    }
    onFilterTimeChange({
      from: newFrom,
      to: newTo,
      timeFrequency,
    })
    // Gửi request với giá trị mới
    const fromParams = parseValueToParams(newFrom, timeFrequency)
    const toParams = parseValueToParams(newTo, timeFrequency)
    dispatch(
      getHistoricalChangeThunk({
        OrganizationId: params.organizationId,
        TimeFrequency: timeFrequency,
        FromYear: fromParams.Year || '',
        FromQuater: fromParams.Quarter || '',
        FromMonth: fromParams.Month || '',
        ToYear: toParams.Year || '',
        ToQuater: toParams.Quarter || '',
        ToMonth: toParams.Month || '',
      }),
    )
  }
  const handleChooseTo = (item) => {
    const toIndex = options.findIndex((opt) => opt.value === item.value)
    const fromIndex = from
      ? options.findIndex((opt) => opt.value === from.value)
      : -1
    let newTo = item
    let newFrom = from
    // Nếu chọn to cũ hơn from (toIndex > fromIndex) thì cập nhật from = to
    if (from && toIndex > fromIndex) {
      newFrom = item
    }
    onFilterTimeChange({
      from: newFrom,
      to: newTo,
      timeFrequency,
    })
    const fromParams = parseValueToParams(newFrom, timeFrequency)
    const toParams = parseValueToParams(newTo, timeFrequency)
    dispatch(
      getHistoricalChangeThunk({
        OrganizationId: params.organizationId,
        TimeFrequency: timeFrequency,
        FromYear: fromParams.Year || '',
        FromQuater: fromParams.Quarter || '',
        FromMonth: fromParams.Month || '',
        ToYear: toParams.Year || '',
        ToQuater: toParams.Quarter || '',
        ToMonth: toParams.Month || '',
      }),
    )
  }

  return (
    <Element
      className={s.container}
      style={{
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? 'none' : 'auto',
      }}
    >
      <Translate value="riskScaleAndInterpretation.from" />
      <SelectCustom
        activeItem={from || {}}
        data={options}
        chooseItem={handleChooseFrom}
        style={{
          marginRight: 4,
          fontSize: 12,
          padding: '4px 12px',
          minWidth: 70,
        }}
        disabled={isDisabled}
      />
      <Translate value="riskScaleAndInterpretation.to" />
      <SelectCustom
        activeItem={to || {}}
        data={options}
        chooseItem={handleChooseTo}
        style={{
          marginRight: 4,
          fontSize: 12,
          padding: '4px 12px',
          minWidth: 70,
        }}
        disabled={isDisabled}
      />
    </Element>
  )
}

export default FilterTime
